<template>
  <v-dialog v-model="showDialog" width="500">
    <v-card :light="lightTheme" class="browser-compat-dialog">
      <v-btn
        rounded
        @click="closeDialog"
        :light="lightTheme"
        class="close-btn"
        height="40"
        width="40"
        icon
      >
        <v-icon small>$close</v-icon>
      </v-btn>
      <v-card-title> {{ $t('global.browserCompatibility') }} </v-card-title>
      <v-divider />
      <v-container>
        <template v-if="notCompatible">
          <v-row justify="center" dense>
            <v-col class="browser-error">
              <v-icon x-large>$alert3Icon</v-icon>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="browser-error">
              {{ $t('global.browserUnsupported') }}
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="px-6">
              <div>
                <div>
                  {{ $t('global.upgradeBrowser') }}
                </div>
                <div class="mt-4">
                  {{ $t('global.browser') }}: <strong>{{ browserType }}</strong>
                </div>
                <div>
                  {{ $t('global.version') }}:
                  <strong>
                    {{ browserVersion }}
                  </strong>
                </div>
              </div>
            </v-col>
          </v-row>
        </template>
        <v-row>
          <v-col cols="12">
            <v-data-table
              :headers="headers"
              :items="browsers"
              disable-pagination
              disable-filtering
              class="browser-compat-table"
              hide-default-footer
              :footer-props="{
                'disable-items-per-page': true,
                'disable-pagination': true,
              }"
            ></v-data-table>
          </v-col>
        </v-row>
        <v-row>
          <v-col align-items="center" cols="12">
            <v-btn
              color="secondary"
              @click="closeDialog"
              block
              style="width: 100%"
            >
              {{ $t('global.close') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'BrowserCompatDialog',
  props: {
    lightTheme: {
      type: Boolean,
    },
  },
  data() {
    return {
      notCompatible: false,
      showDialog: false,
      browsers: [
        {
          type: this.$t('global.chrome'),
          version: '77',
        },
        {
          type: this.$t('global.firefox'),
          version: '74',
        },
        {
          type: this.$t('global.edge'),
          version: '80',
        },
        {
          type: this.$t('global.safari'),
          version: '12.1',
        },
      ],
      headers: [
        {
          text: this.$t('global.supportedBrowsers'),
          value: 'type',
          sortable: false,
        },
        {
          text: this.$t('global.minimumVersion'),
          value: 'version',
          sortable: false,
        },
      ],
    }
  },
  methods: {
    openDialog() {
      this.showDialog = true
    },
    closeDialog() {
      this.showDialog = false
      this.$emit('closeDialog')
    },
    checkBrowser() {
      let browser = this.$browserDetect
      if (browser.isIOS) {
        return
      }
      if (browser.isChrome && this.browserVersion < 77) {
        this.showDialog = true
        this.notCompatible = true
      } else if (browser.isFirefox && this.browserVersion < 74) {
        this.showDialog = true
        this.notCompatible = true
      } else if (browser.isSafari && this.browserVersion < 12) {
        this.showDialog = true
        this.notCompatible = true
      } else if (browser.isEdge && this.browserVersion < 80) {
        this.showDialog = true
        this.notCompatible = true
      } else {
        return
      }
    },
  },
  created() {
    this.checkBrowser()
  },
  computed: {
    browserVersion() {
      return this.$browserDetect.meta.version
    },
    browserType() {
      return this.$browserDetect.meta.name
    },
  },
})
</script>

<style lang="scss">
.browser-compat-dialog {
  .close-btn {
    float: right;
    margin-top: 5px;
    margin-right: 5px;
    right: 0;
  }
  .browser-error {
    text-align: center;
    color: $color-secondary;
  }
}
</style>
